import {z} from "zod";
import {UiComponentBaseSchema} from "./UiComponent";

export const LayoutContainerBaseSchema = UiComponentBaseSchema.extend({});

export const LayoutContainerSchema = z.lazy(() => {
    const {GridLayoutContainerSchema} = require("./GridLayoutContainer");
    return z.discriminatedUnion('componentType', [
        GridLayoutContainerSchema,
    ]);
});

export type LayoutContainer = z.infer<typeof LayoutContainerSchema>;